











































import { Component, Vue } from "vue-property-decorator";
import {Getter} from "vuex-class";
import {db} from "../../db";

@Component
export default class Uploads extends Vue {
    @Getter uploads;
    private search = '';

    private headers = [
        {
            text: 'Status',
            value: 'error',
        },
        { text: 'Created', value: 'created' },
        { text: 'Text', value: 'text' },
        { text: 'Delete', value: 'delete' }
    ];

    async status(item) {
        await db.doc(`uploads/${item.id}`).update({error: !item.error})
    }

    async deleteItem(item) {
        await db.doc(`uploads/${item.id}`).delete()
    }

    formatCreated( item) {
        if( item.created ) {
            const date = item.created.toDate()
            if( date.getFullYear() != 1969) {
                return date.toLocaleString();
            }
        }
        return 'N/A';
    }

}
